import React from 'react';
import { useUnemploymentProfiling } from '../hooks/useUnemploymentProfiling';
import { PossibleAnswer, Question } from '../types/interfaces';
import { ProfilingQuestion } from './ProfilingQuestion';
import { StepperIndicator } from './StepIndicator';

interface QuestionsGroupProps {
  questions: Question[];
  answers: Record<string, any>;
  onAnswer: (key: string, answer: PossibleAnswer[]) => void;
}

export const QuestionsGroup: React.FC<QuestionsGroupProps> = ({
  questions,
  answers,
  onAnswer
}) => {
  const {
    progress,
  } = useUnemploymentProfiling();

  return (
    <div className="w-3/4 mx-auto flex flex-col gap-4">
      {questions.map((question, index) => (
        <ProfilingQuestion
          key={question.key + index}
          question={question}
          currentAnswers={answers[question.key] || []}
          onAnswer={onAnswer}
        />
      ))}
      <StepperIndicator
        current={progress.current}
        total={progress.total}
      />
    </div>
  );
};
